// extracted by mini-css-extract-plugin
export default {"item":"MainMenuCard_item__kAr8H","content":"MainMenuCard_content__gUTCz","title":"MainMenuCard_title__4IR7J","icon":"MainMenuCard_icon__0-bnA"};